

import TwoFAForm from "../../forms/twoFaForm";

const TwoFA = () => {
    return (
        <div>
            <TwoFAForm />
        </div>
    )
}

export default TwoFA;